import {
  GetAgenticLogicRuleVersionDetailRequestPathParamsType,
  GetAgenticLogicRuleVersionDetailResponseBodyType,
} from "@intelligems/ig-types/functions/agentic-logic/versions/get";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const getAgenticLogicRuleVersionDetail = async (
  pathParams: GetAgenticLogicRuleVersionDetailRequestPathParamsType
) => {
  const resp = await api.get<GetAgenticLogicRuleVersionDetailResponseBodyType>(
    `/v2/agentic-logic/rules/${pathParams.ruleId}/versions/${pathParams.version}`
  );
  return resp.data;
};

export const useAgenticLogicRuleVersionDetail = (
  ruleId: string | undefined,
  version: number | null
) => {
  return useQuery<GetAgenticLogicRuleVersionDetailResponseBodyType, Error>({
    queryKey: agenticLogicKeys.versionDetail(ruleId!, version ?? -1),
    queryFn: async () =>
      getAgenticLogicRuleVersionDetail({
        ruleId: ruleId!,
        version: String(version!),
      }),
    enabled: !!ruleId && version !== null,
  });
};
